module.exports = __webpack_public_path__ + "img/lang_setting2.c0ced3f8.png";